import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import { ArrowRight } from 'lucide-react';
import { Trans } from 'react-i18next';
import { getLocalizedPath } from 'helpers/getLocale';
import useTranslate from 'hooks/useTranslate';

const Background = styled('section')(({ theme }) => ({
  backgroundColor: theme.palette.white.main
}));

const Wrapper = styled('div')(({ theme }) => ({
  maxWidth: 1030,
  width: '100%',
  margin: '0 auto',
  padding: '0 0 50px',
  boxSizing: 'border-box',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '100%',
    padding: '0 50px 50px'
  },
  [theme.breakpoints.down('md')]: { padding: '0 30px 30px' },
  [theme.breakpoints.down('sm')]: { padding: '0 20px 30px' }
}));

const Copy = styled(Typography)(({ theme }) => ({
  color: theme.palette.textPrimary.main,
  textAlign: 'center',
  '& strong': { fontWeight: 600 }
}));

const ProLink = styled(Link)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  textDecoration: 'underline',
  textUnderlineOffset: 3,
  color: theme.palette.primary.main,
  fontFamily: 'inherit',
  fontWeight: 600,
  '& svg': { transition: 'transform 0.2s ease' },
  '&:hover svg': { transform: 'translateX(4px)' }
}));

const ProLinkWithArrow = ({ children, to }) => (
  <ProLink to={to}>
    {children}
    <ArrowRight size={16} />
  </ProLink>
);

const ProTeaser = () => {
  const tHome = useTranslate('Home');
  return (
    <Background>
      <Wrapper>
        <Copy variant="body1">
          <strong>{tHome('ProTeaserLead')}</strong>
          <br />
          <Trans
            i18nKey="Home.ProTeaserBlurb"
            components={{ 1: <ProLinkWithArrow to={getLocalizedPath('/pro')} /> }}
          />
        </Copy>
      </Wrapper>
    </Background>
  );
};

export default ProTeaser;
